/* eslint-disable no-unused-vars */

import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";

const openMessage = (detail, error) => {
  if (error) {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: { message: detail, error: error },
      })
    );
  } else {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: detail,
      })
    );
  }
};

const closeMessage = (detail, error) => {
  document.dispatchEvent(
    new CustomEvent("close-editor-popup", {
      detail: detail,
    })
  );
};

const askMessage = (detail, onYes, onNo) => {
  document.dispatchEvent(
    new CustomEvent("ask-editor-popup", {
      detail: { message: detail, onYes: onYes, onNo: onNo },
    })
  );
};

function ModalPopup() {
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState(false);
  const [ask, setAsk] = useState(false);
  const [onYes, setOnYes] = useState(() => () => { });
  const [onNo, setOnNo] = useState(() => () => { });
  const [notification, setNotification] = useState("");

  useEffect(() => {
    document.addEventListener("open-editor-popup", showPopup.bind(this));
    document.addEventListener("close-editor-popup", hidePopup.bind(this));
    document.addEventListener("ask-editor-popup", askPopup.bind(this));
    document.addEventListener(
      "update-editor-popup",
      updateNotification.bind(this)
    );
  }, []);

  const updateNotification = (event) => {
    let detail = event.detail;
    setNotification(detail);
  };

  const showPopup = (event) => {
    let detail = event.detail;
    setModalOpen(true);
    if (detail.message) {
      setError(detail.error);
      setNotification(detail.message);
    } else {
      setNotification(detail);
    }
  };

  const askPopup = (event) => {
    let detail = event.detail;
    setModalOpen(true);
    if (detail.message) {
      setError(detail.error);
      setNotification(detail.message);
      setOnYes(() => () => detail.onYes());
      setOnNo(() => () => detail.onNo());
      setAsk(true);
    } else {
      setNotification(detail);
    }
  };

  const hidePopup = (event) => {
    if (event) {
      setNotification(event.detail);
      setError(false);
      setAsk(false);
      setTimeout(() => {
        setModalOpen(false);
      }, 1000);
    } else {
      setModalOpen(false);
      setError(false);
      setAsk(false);
      setOnYes(() => { });
      setOnNo(() => { });
    }
  };

  const onYesF = () => {
    if (onYes) onYes();
    hidePopup();
  };

  const onNoF = () => {
    if (onNo) onNo();
    hidePopup();
  };

  return (
    <div>
      <Modal
        onOpen={() => setModalOpen(true)}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        className="commentRepModal"
        dimmer="blurring"
        size="small"
        closeOnDimmerClick={false}
      >
        <Modal.Content>
          <div className="loadingModal">
            <div className="lds-default">
              <p>{notification}</p>
            </div>
          </div>
        </Modal.Content>

        <Modal.Actions style={{ display: error ? "block" : "none" }}>
          <Button onClick={() => hidePopup()} positive>
            Ok
          </Button>
        </Modal.Actions>

        <Modal.Actions style={{ display: ask ? "block" : "none" }}>
          <Button onClick={() => onNoF()} negative>
            No
          </Button>
          <Button onClick={() => onYesF()} positive>
            Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

const FormModalPopup = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [submit, setSubmit] = useState(() => () => { });
  const [reject, setReject] = useState(() => () => { });
  const [formFields, setFormFields] = useState([]);
  const [submitFields, setSubmitFields] = useState([]);

  useEffect(() => {
    document.addEventListener("open-form-popup", initFormPopup.bind(this));
    document.addEventListener("close-form-popup", hidePopup.bind(this));
    document.addEventListener("update-form-popup", updatePopup.bind(this));

    return () => {
      document.removeEventListener("open-form-popup", initFormPopup.bind(this));
      document.removeEventListener("close-form-popup", hidePopup.bind(this));
      document.addEventListener("update-form-popup", updatePopup.bind(this));
    };
  }, []);

  function initFormPopup(event) {
    console.log("initFormPopup", event);
    const detail = event.detail;
    setModalOpen(true);
    setSubmit(() => (val) => detail.onSubmit(val));
    setReject(() => (val) => detail.onReject(val));
    setFormFields(detail.formFields);
    setSubmitFields(
      detail.formFields.map((field) => ({
        value: field.value,
        name: field.name,
      }))
    );
  }

  function updatePopup(event) {
    const detail = event.detail;
    setFormFields(detail.formFields);
    setSubmitFields(
      detail.formFields.map((field) => ({
        value: field.value,
        name: field.name,
      }))
    );
  }

  function hidePopup() {
    setModalOpen(false);
    setFormFields([]);
    setSubmitFields([]);
  }

  const handleInputChange = (index, newValue) => {
    setSubmitFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index ? { ...field, value: newValue } : field
      )
    );
    setFormFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index ? { ...field, value: newValue } : field
      )
    );
  };

  const generateFormFields = (fields) => {
    return fields.map((field, index) => {
      if (field.type === "text") {
        return (
          <div key={field.name + index} className="formField">
            <label>{field.label}</label>
            <input
              autoFocus
              type="text"
              value={submitFields[index]?.value || ""}
              onChange={(e) => handleInputChange(index, e.target.value)}
            />
          </div>
        );
      } else if (field.type === "select") {
        return (
          <div key={field.name + index} className="formField">
            <label>{field.label}</label>
            <select
              value={submitFields[index]?.value}
              onChange={(e) => handleInputChange(index, e.target.value)}
            >
              {field.options.map((option, optionIndex) => (
                <option key={option.value + optionIndex} label={option.label} value={option.value} />
              ))}
            </select>
          </div>
        );
      }
    });
  };

  return (
    <div>
      <Modal
        onOpen={() => setModalOpen(true)}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        style={{ width: "25%" }}
        dimmer="blurring"
        size="small"
        closeOnDimmerClick={true}
      >
        <Modal.Content>
          <div className="loadingModal">
            <div className="lds-default">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submit(submitFields);
                }}
              >
                {generateFormFields(formFields)}
              </form>
            </div>
          </div>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => reject()} negative>
            No
          </Button>
          <Button onClick={() => submit(submitFields)} positive>
            Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export { askMessage, closeMessage, FormModalPopup, ModalPopup, openMessage };

